/**
 * Keys that live on a formula / additive row but are **not** nutrients.
 *
 * Every nutrient a formula holds is stored as a bare property named
 * `availableNutritions[i].englishName.toLowerCase()`, so "is this key a
 * nutrient?" is answered by elimination. Anything missing from this list gets
 * swept into the numeric-coercion and `visibleNutrients` paths and then renders
 * as a bogus nutrient row in the edit form and the details panel.
 *
 * This used to be copy-pasted in five places (NutritionConfig ×2,
 * AddEditFormula ×3), which is exactly how `allow_continuous_feeding` became a
 * documented trap. Import it instead of re-typing it.
 */
export const RESERVED_FORMULA_KEYS = [
    'name',
    'id',
    'rate',
    'totalMl',
    'value',
    'per',
    'instructions',
    'per_meals_calculation',
    'allow_continuous_feeding',
    // Additives only: the percentage of the base feed's volume pre-filled in the
    // calculator. A percentage, not a nutrient — must never be summed per unit.
    'defaultPercent',
];

/** True when `key` carries a nutrient value rather than row metadata. */
export const isNutrientKey = (key) => !RESERVED_FORMULA_KEYS.includes(key);
